import { Injectable } from '@angular/core';
import { PartnerPendingStore } from './partner-pending.store';
import { PartnerPending } from './partner-pending.model';
import { tap, mapTo, switchMapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';

@Injectable({ providedIn: 'root' })
export class PartnerPendingService {

  constructor(private partnerPendingStore: PartnerPendingStore,
              private api: ApiService) {
  }

  fetchPartnersPending() {
    return this.api.get<PartnerPending>('partners/pending').pipe(
      tap(entities => {
        this.partnerPendingStore.set(entities);
      }),
      mapTo(null)
    );
  }

  add(fullName: string, partnerEmail: string, comments: string) {
    return this.api.post('partners/invite', { fullName, partnerEmail, comments })
    .pipe(
      switchMapTo(this.fetchPartnersPending())
    );
  }

  remove(ticketKey: string) {
    return this.api.delete(`partners/delete`, `${ticketKey}`)
    .pipe(
      tap(this.partnerPendingStore.remove(ticketKey))
    );
  }
}
